import React, { Dispatch, SetStateAction } from "react"
import { Scrollbar } from "../../Constants/StyledComponents"
import { Outlet, Route, Routes, useLocation } from "react-router-dom"
import PageHeader from "../../Components/PageHeader/PageHeader"
import InternalPageHeader from "../../Pages/Internal/InternalPageHeader"
import UserTabs from "../../Pages/Admin/Users/UserTabs"
import Sidebar from "../../Components/SideBar/Sidebar"
import { useAuthProvider } from "../../Providers/AuthProvider"
import { FRONTEND_LINKS } from "../../Constants/FrontendLinks"

type MainLayoutProps = {
    navPage: boolean
    sidebar: boolean
    setNavPage: Dispatch<SetStateAction<boolean>>
    setSidebar: Dispatch<SetStateAction<boolean>>
}

export const MainLayout: React.FC<MainLayoutProps> = ({ navPage, sidebar, setNavPage, setSidebar }) => {
    const authProvider = useAuthProvider()
    const location = useLocation()
    const isInternalPage = location.pathname.startsWith(FRONTEND_LINKS.SUBPAGES.INTERNAL.MAIN)
    const showAppSidebar = navPage && !isInternalPage
    return (
    <>
        {showAppSidebar &&
            <Sidebar
                sidebar={sidebar}
                setSidebar={setSidebar}
            />
        }

        <div id='HeaderAndPage' style={{ height: "100vh", display: "flex", flexDirection: "column", backgroundColor: 'var(--color-surface-primary)' }}>

            {navPage && authProvider.userIsLoggedIn && (<>
                {isInternalPage ? (
                    <InternalPageHeader />
                ) : (
                    <PageHeader
                        setNavPage={setNavPage}
                        sidebar={sidebar}
                        setSidebar={setSidebar}
                    />
                )}

                <Routes>
                    <Route path={`${FRONTEND_LINKS.SUBPAGES.ADMIN.SUBPAGES.USER_MANAGEMENT.MAIN}/*`} element={<UserTabs />} />
                    <Route path="*" element={null} />
                </Routes>

            </>)}

            <Scrollbar style={{ flex: 1, display: "flex", alignItems: "center", background: navPage ? 'var(--color-surface-primary)' : 'var(--color-surface-panel)', }}>
                <div
                  style={{
                    width: showAppSidebar ? 'calc(100vw - 106px)' : '100vw',
                    height: "100%",

                    marginLeft: showAppSidebar ? '106px' : '0px',
                    transition: 'margin-left 0.18s cubic-bezier(.4,0,.2,1), width 0.18s cubic-bezier(.4,0,.2,1)'
                  }}
                >
                    <Outlet /> {/* This is where the route element actually gets rendered */}
                </div>
            </Scrollbar>
        </div>
    </>)
}